"use client";
import {useContext, useEffect} from "react";
import UserInfoContext from "./contexts/userInfoContext";
import {isAdmin, isParent, isStaff, isStudent} from "../util/userUtils";
import {useCookieCampusId} from "./contexts/CampusCookieContext";

/**
 * Utility component which attaches some variables to the window object for analytics tagging.
 *
 * @returns null
 */
const AnalyticsVariablesSetter = () => {
	const {userInfo} = useContext(UserInfoContext);
	const campusId = useCookieCampusId();
	useEffect(() => {
		window.analytics = {
			isLoggedIn: !!userInfo,
			isAdmin: userInfo && isAdmin(userInfo),
			isStaff: userInfo && isStaff(userInfo),
			isStudent: userInfo && isStudent(userInfo),
			isParent: userInfo && isParent(userInfo),
			currentCampus: campusId,
			userEmail: userInfo?.email,
			userHomeCampus: userInfo?.campus_id,
		};
		window.dataLayer?.push(window.analytics);
	}, [userInfo, campusId]);
	return null;
};

export default AnalyticsVariablesSetter;
